import SearchParamsBase from '../../../Elements/SearchParamsBase';
import InputTypesEnum from '../../../Enums/InputTypesEnum';

// Filters of the grouped template list. The field names are the backend search item's, which both
// template lists share and each exposes a subset of. No language or data-type filter on purpose:
// a template holds one data type, and a single-variant one is almost always en_US.
export default class TemplateGroupSearchParams extends SearchParamsBase {
  initialize() {
    this.NameContains = '';
    this.IsActive = '';
  }

  static iconName = 'fa-solid fa-search';
  static saveType = 'TemplateGroupSearchParams';

  static fieldsInSearchBox = [
    {
      fieldName: 'NameContains',
      label: 'Template Name',
      className: 'col-6',
      type: InputTypesEnum.Text,
    },
    {
      fieldName: 'IsActive',
      label: 'Has An Active Variant?',
      className: 'col-6',
      type: InputTypesEnum.EmptyYesNoSelect,
    },
  ];
}
